// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"df55b752334be01e7e4d","203":"f4d8d3e0b8adfef3d833","243":"307c1cf31df043fbcfea","395":"ba4aa7287b391fa32b6f","556":"edb42d2630c552e3bb28","720":"e986df59120b9443ada3","852":"f4e5150ed9206ecb7fe7"}[chunkId] + ".bundle.js";
};